module.exports = __webpack_public_path__ + "img/9.5b73f1c7.png";